module.exports = __webpack_public_path__ + "static/media/dx-mail.57a03cb2.svg";